// Typed wrappers around `/api/staff/departments/*` (feature F-A). Admin-only.

import { getApiClient } from "./client";
import type { components } from "./types";

export type Department = components["schemas"]["DepartmentResponse"];
export type DepartmentCreate = components["schemas"]["DepartmentCreate"];
export type DepartmentUpdate = components["schemas"]["DepartmentUpdate"];
export type MessageResponse = components["schemas"]["MessageResponse"];

export async function listDepartments(
  includeDeleted = false,
): Promise<Department[]> {
  const { data } = await getApiClient().get<Department[]>(
    "/staff/departments",
    { params: includeDeleted ? { include_deleted: true } : {} },
  );
  return data;
}

export async function createDepartment(
  payload: DepartmentCreate,
): Promise<Department> {
  const { data } = await getApiClient().post<Department>(
    "/staff/departments",
    payload,
  );
  return data;
}

export async function updateDepartment(
  departmentId: string,
  payload: DepartmentUpdate,
): Promise<Department> {
  const { data } = await getApiClient().patch<Department>(
    `/staff/departments/${departmentId}`,
    payload,
  );
  return data;
}

export async function deleteDepartment(
  departmentId: string,
): Promise<MessageResponse> {
  const { data } = await getApiClient().delete<MessageResponse>(
    `/staff/departments/${departmentId}`,
  );
  return data;
}
